<template>
    <div>
        <div ref="button"></div>
    </div>
</template>

<script>
export default {
    name: 'PaypalButton',

    props: {
        price: {
            required: true
        },

        track: {
            default: null
        }
    },

    mounted () {
        this.$nextTick(() => {
            window.paypal.Buttons({
                style: {
                    tagline: false
                },
                createOrder: (data, actions) => {
                    this.$emit('creating')
                    return actions.order.create({
                        purchase_units: [{
                            amount: {
                                value: this.price
                            }
                        }]
                    });
                },

                onApprove: (data, actions) => {
                    return actions.order.capture().then((details) => {
                        var payload = details
                        if (this.track) {
                            payload['track'] = this.track
                        }
                        this.$emit('success', payload)
                    });
                },

                onError: (e) => {
                    this.$emit('error', e)
                },

                onCancel: (e) => {
                    this.$emit('cancel', e)
                }
            }).render(this.$refs.button);
        })
    }
}
</script>
